import React from 'react';
import Modal from '../../../../../../shared/design-system/components/atoms/modal';
import Button from '../../../../../../shared/design-system/components/atoms/button';
import { McpSession } from '../../types';

type Props = {
  show: boolean;
  session: McpSession | null;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const McpDisconnectModal: React.FC<Props> = ({
  show,
  session,
  isLoading,
  onClose,
  onConfirm,
}) => (
  <Modal
    show={show}
    className="mcp-disconnect-modal"
    titleContent={<span>Disconnect Access</span>}
    showCloseIcon
    onClose={onClose}
    onHide={onClose}
    submitButtonText="Disconnect"
    submitButtonVariant={Button.Variant.Danger}
    cancelButtonText="Cancel"
    isSubmitLoading={isLoading}
    onSubmit={onConfirm}
  >
    <div className="mcp-disconnect-modal__body">
      <p>
        Revoking access for{' '}
        <strong>{session?.clientName || 'Unknown Client'}</strong> will
        immediately disconnect it from Saleshandy.
      </p>
      <p>
        Data and conversations will no longer be available. Sequences and
        prospect data will be disabled.
      </p>
      <p>You can reconnect by clicking 'Set Up MCP' at any time.</p>
    </div>
  </Modal>
);

export default McpDisconnectModal;
